import { get, put } from './clients/admin'

export const addDonor = async ({ donorName, fcpId }) => {
  return await put('/donors', { name: donorName, FCP: fcpId.toUpperCase() })
}

export const getDonors = async () => {
  return await get('/donors')
}
